import { useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { copyText } from "@/copy/copy";
import { appPath, MOBILE_MORE, MOBILE_PRIMARY, NAV } from "./nav";

// v47's bar: Actions takes the priorities glyph and Budget the net worth one (tools/build-mobile.py).
const ICON: Record<string, string> = {
  home: '<path d="M3 10.5 12 3l9 7.5V20a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1z"/>',
  cashflow: '<path d="M3 6h18v12H3z"/><circle cx="12" cy="12" r="2.6"/>',
  budget: '<path d="M3 17l5-5 4 3 7-8"/><path d="M15 7h5v5"/>',
  actions: '<path d="M5 4h14v6a7 7 0 0 1-14 0z"/><path d="M9 20h6M12 17v3"/>',
  more: '<circle cx="5" cy="12" r="1.6"/><circle cx="12" cy="12" r="1.6"/><circle cx="19" cy="12" r="1.6"/>',
};

function Icon({ name }: { name: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: ICON[name] }}
    />
  );
}

/**
 * The phone-width bottom tab bar (Home, Actions, Cash flow, Budget, More) and its More sheet (the
 * prototype's mobile layer). Actions carries the warning dot while the plan runs short.
 */
export function MobileTabs({ activeKey, short }: { activeKey: string; short: boolean }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const go = (path: string) => {
    setOpen(false);
    if (location.pathname !== appPath(path)) navigate(appPath(path));
    window.scrollTo(0, 0);
  };
  const more = MOBILE_MORE.map((key) => NAV.find((n) => n.key === key)!);
  return (
    <>
      <nav className="mtabs" aria-label="Main">
        {MOBILE_PRIMARY.map((key) => {
          const item = NAV.find((n) => n.key === key)!;
          return (
            <button
              key={key}
              type="button"
              className={`mtab${activeKey === key ? " on" : ""}`}
              onClick={() => go(item.path)}
              data-testid={`mtab-${key}`}
            >
              <Icon name={key} />
              <b>{key === "cashflow" ? "Cash flow" : copyText(item.label)}</b>
              {key === "actions" && short && (
                <span className="dotwarn" aria-label="Your plan runs short" />
              )}
            </button>
          );
        })}
        <button
          type="button"
          className={`mtab${!MOBILE_PRIMARY.includes(activeKey) ? " on" : ""}`}
          onClick={() => setOpen((o) => !o)}
          aria-expanded={open}
          data-testid="mtab-more"
        >
          <Icon name="more" />
          <b>More</b>
        </button>
      </nav>
      <div
        className={`msheet${open ? " on" : ""}`}
        onClick={(e) => e.target === e.currentTarget && setOpen(false)}
      >
        {open && (
          <div className="msheet-in" role="dialog" aria-label="Everything else">
            <div className="grab" />
            <h3>Everything else</h3>
            {more.map((item) => (
              <button
                key={item.key}
                type="button"
                className="msheet-row"
                onClick={() => go(item.path)}
              >
                <span className="ic2">{item.icon}</span>
                {copyText(item.label)}
              </button>
            ))}
          </div>
        )}
      </div>
    </>
  );
}
